<template>
  <div class="general-data">
    <el-row>
      <el-col class="general-header">
        <h1>Datos generales</h1>
      </el-col>
    </el-row>
    <br><br>
    <el-form
      ref="formInvoice"
      :model="model"
      :rules="rules"
      @submit.native.prevent="onSubmit">
      <el-row :gutter="20">
        <el-col
          :xs="24"
          :sm="16"
          :md="16"
          :lg="16"
          :xl="16"
          class="col">
          <label>Nombre fiscal</label>
          <el-form-item
            prop="fiscalName"
            class="form-item">
            <el-input
              v-model="model.fiscalName"/>
          </el-form-item>
        </el-col>
        <el-col
          :xs="24"
          :sm="8"
          :md="8"
          :lg="8"
          :xl="8"
          class="col">
          <label>RFC</label>
          <el-form-item
            prop="rfc"
            class="form-item">
            <el-input
              v-model="model.rfc"/>
          </el-form-item>
        </el-col>
        <el-col
          :span="24"
          class="col">
          <label>Email</label>
          <el-form-item
            prop="email"
            class="form-item"/>
          <el-input
            v-model="model.email"/>
        </el-col>

        <el-col
          :span="24"
          class="btns">
          <el-button native-type="submit">Guardar</el-button>
          <el-button
            type="text"
            @click="goToInvoice">Cancelar</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import AddAddressModel from '@/models/add-new-address-invoice.model'

export default {
  name: 'AddAddressInvoice',
  data () {
    return {
      model: AddAddressModel.model(),
      rules: AddAddressModel.rules,
      value1: ''
    }
  },
  methods: {
    onSubmit () {
      this.$refs.formAddInvoice.validate((valid) => {
        if (valid) {
          alert('PASSS')
        }
      })
    },
    goToInvoice () {
      this.$router.push('invoice')
    }
  }
}
</script>

<style lang="scss" scoped>

  .general-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E3E6EA;
    padding-bottom: 15px;
    h1{
      margin: 0;
      @include font-primary(14px, semibold)
    }
  }
  .btns{
    margin-top: 10px;
    button{
      &:first-child{
        background-color: $roseHeader;
        white-space: normal;
        @include font-primary(12px, bold);
        color: white;
        border: none;
        width: 95px;
        border-radius: 3px;
      }
      &:nth-child(2){
        white-space: normal;
        @include font-primary(12px, bold);
        color: $roseHeader;
        border: none;
        width: 95px;
      }
    }
  }

  .el-form-item{
    margin-bottom: 0 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/user-profile/add-address-invoice.vue